<section class="citations-page">
    <div class="citations-shell-header">
        <div class="asset-select-group">
            <label class="asset-select-label" for="citation-asset-select">Asset</label>
            <select
                id="citation-asset-select"
                class="asset-select"
                [ngModel]="selectedAssetTag"
                (ngModelChange)="onAssetSelectionChange($event)">
                <option [ngValue]="''" disabled>-- select asset --</option>
                <option *ngFor="let assetTag of assetTagOptions" [ngValue]="assetTag">{{ assetTag }}</option>
            </select>
        </div>
    </div>

    <div class="citations-grid" #citationsGrid>
        <aside class="source-files-panel grid-panel" [style.flexBasis.%]="leftPanelWidthPercent">
            <div class="panel-header">
                <h3>Source Files</h3>
            </div>

            <div class="panel-content">
                <div class="panel-empty" *ngIf="isLoadingTimeline">Loading source files...</div>
                <div class="panel-empty error" *ngIf="!isLoadingTimeline && hasTimelineLoadError">Unable to load citation timeline.</div>
                <div class="panel-empty" *ngIf="!isLoadingTimeline && !hasTimelineLoadError && sourceFiles.length === 0">Load a citations.json to begin</div>

                <ul *ngIf="!isLoadingTimeline && !hasTimelineLoadError && sourceFiles.length > 0">
                    <li *ngFor="let sourceFile of sourceFiles">
                        <button
                            type="button"
                            class="source-file-name"
                            [class.active]="selectedSourceFile.toLowerCase() === sourceFile.toLowerCase()"
                            [title]="sourceFile"
                            (click)="onSourceFileClick(sourceFile)">
                            {{ sourceFile }}
                        </button>
                    </li>
                </ul>
            </div>
        </aside>

        <div
            class="resize-handle"
            role="separator"
            aria-label="Resize source files panel"
            (mousedown)="onResizeStart('left', $event)"></div>

        <section class="timeline-panel grid-panel" [style.flexBasis.%]="centerPanelWidthPercent">
            <div class="panel-header">
                <h3>Citation Timeline</h3>
            </div>

            <div class="panel-content">
                <div class="panel-empty" *ngIf="isLoadingManifest || isLoadingTimeline">Loading citations...</div>
                <div class="panel-empty error" *ngIf="!isLoadingManifest && !isLoadingTimeline && (hasManifestLoadError || hasTimelineLoadError)">
                    Unable to load citations for this run.
                </div>

                <ng-container *ngIf="!isLoadingManifest && !isLoadingTimeline && !hasManifestLoadError && !hasTimelineLoadError">
                    <div class="timeline-strip" *ngIf="filteredTimelineItems.length > 0">
                        <div class="timeline-strip-scroll">
                            <ol class="timeline-dots-row">
                                <li *ngFor="let item of filteredTimelineItems; let index = index" class="timeline-dot-node">
                                    <button
                                        type="button"
                                        class="timeline-dot"
                                        [class.active]="activeCitationIndex === index"
                                        [attr.aria-label]="'Open citation ' + item.citation_id"
                                        [title]="item.citation_id"
                                        (click)="onTimelineDotClick(index)">
                                        Open citation {{ index + 1 }}
                                    </button>
                                    <span class="timeline-date-label">{{ getTimelineDateLabel(item.date) }}</span>
                                </li>
                            </ol>
                        </div>
                    </div>

                    <div class="panel-empty" *ngIf="filteredTimelineItems.length === 0">Select a source file from the left panel to view citations.</div>

                    <div class="source-document-viewer" *ngIf="filteredTimelineItems.length > 0">
                        <div class="source-document-empty" *ngIf="isLoadingSourcePreview && sourcePreviewType !== 'pdf'">
                            Loading source document...
                        </div>

                        <div class="source-document-empty error" *ngIf="!isLoadingSourcePreview && sourcePreviewError">
                            {{ sourcePreviewError }}
                        </div>

                        <div class="source-document-empty" *ngIf="!isLoadingSourcePreview && !sourcePreviewError && sourcePreviewType === 'none'">
                            Select a timeline citation to load the source document.
                        </div>

                        <div class="source-document-csv" #csvTableContainer *ngIf="!isLoadingSourcePreview && !sourcePreviewError && sourcePreviewType === 'csv'">
                            <div class="tabular-jump-label" *ngIf="sourceCsvHighlightedRowNumber">
                                Jumped to row {{ sourceCsvHighlightedRowNumber }}
                            </div>

                            <table *ngIf="sourceCsvRows.length > 0" class="csv-preview-table">
                                <thead>
                                    <tr>
                                        <th class="row-number-cell">#</th>
                                        <th *ngFor="let headerCell of sourceCsvRows[0]">{{ headerCell }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let row of sourceCsvVisibleRows" [class.target-row]="row.isTarget">
                                        <td class="row-number-cell">{{ row.dataRowNumber }}</td>
                                        <td *ngFor="let cell of row.cells">{{ cell }}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="source-document-empty" *ngIf="sourceCsvRows.length === 0">
                                CSV file is empty.
                            </div>
                        </div>

                        <div class="source-document-csv" #excelTableContainer *ngIf="!isLoadingSourcePreview && !sourcePreviewError && sourcePreviewType === 'excel'">
                            <div class="tabular-jump-label" *ngIf="sourceExcelHighlightedRowNumber">
                                Jumped to row {{ sourceExcelHighlightedRowNumber }}
                            </div>

                            <table *ngIf="sourceExcelRows.length > 0" class="csv-preview-table">
                                <thead>
                                    <tr>
                                        <th class="row-number-cell">#</th>
                                        <th *ngFor="let headerCell of sourceExcelRows[0]">{{ headerCell }}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let row of sourceExcelVisibleRows" [class.target-row]="row.isTarget">
                                        <td class="row-number-cell">{{ row.dataRowNumber }}</td>
                                        <td *ngFor="let cell of row.cells">{{ cell }}</td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="source-document-empty" *ngIf="sourceExcelRows.length === 0">
                                Excel sheet is empty.
                            </div>
                        </div>

                        <div class="source-document-delta" #deltaRecordsContainer *ngIf="!isLoadingSourcePreview && !sourcePreviewError && sourcePreviewType === 'delta'">
                            <div class="tabular-jump-label" *ngIf="sourceDeltaRowCount > 0">
                                Matched {{ sourceDeltaRowCount }} record{{ sourceDeltaRowCount === 1 ? '' : 's' }}
                            </div>

                            <table class="delta-record-table" *ngFor="let record of sourceDeltaRecords">
                                <tbody>
                                    <tr *ngFor="let field of record">
                                        <th scope="row">{{ field.key }}</th>
                                        <td>
                                            <ng-container *ngFor="let part of field.parts">
                                                <mark *ngIf="part.highlighted" class="source-record-highlight">{{ part.text }}</mark>
                                                <ng-container *ngIf="!part.highlighted">{{ part.text }}</ng-container>
                                            </ng-container>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="source-document-empty" *ngIf="sourceDeltaRecords.length === 0">
                                No matching delta record was found for this citation.
                            </div>
                        </div>

                        <div
                            #pdfViewerContainer
                            *ngIf="sourcePreviewType === 'pdf' && !sourcePreviewError"
                            class="source-document-pdf"
                            [class.loading]="isLoadingSourcePreview"
                            aria-label="PDF document preview">
                            <div
                                *ngFor="let page of pdfPages"
                                class="pdf-page"
                                [class.cited-page]="page.pageNumber === pdfPageNumber"
                                [style.width.px]="page.width"
                                [style.height.px]="page.height"
                                [attr.aria-label]="'PDF page ' + page.pageNumber">
                                <canvas
                                    #pdfPageCanvas
                                    [style.width.px]="page.width"
                                    [style.height.px]="page.height"></canvas>
                                <div
                                    *ngIf="page.highlight && !isLoadingSourcePreview"
                                    class="pdf-citation-highlight"
                                    [style.left.px]="page.highlight.left"
                                    [style.top.px]="page.highlight.top"
                                    [style.width.px]="page.highlight.width"
                                    [style.height.px]="page.highlight.height"></div>
                            </div>
                            <div class="pdf-loading-overlay" *ngIf="isLoadingSourcePreview">
                                <span class="loading-spinner"></span>
                                <span>Loading citation...</span>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </section>

        <div
            class="resize-handle"
            role="separator"
            aria-label="Resize evidence details panel"
            (mousedown)="onResizeStart('right', $event)"></div>

        <aside class="evidence-panel grid-panel" [style.flexBasis.%]="rightPanelWidthPercent">
            <div class="panel-header">
                <h3>Evidence Details</h3>
            </div>

            <div class="panel-content">
                <div class="panel-empty" *ngIf="isLoadingEvidenceDetails">Loading evidence details...</div>
                <div class="panel-empty error" *ngIf="!isLoadingEvidenceDetails && hasEvidenceDetailsLoadError">Unable to load evidence details.</div>

                <div class="panel-empty" *ngIf="!isLoadingEvidenceDetails && !hasEvidenceDetailsLoadError && !selectedAssetEvidence">
                    Select an asset to view evidence details.
                </div>

                <ng-container *ngIf="selectedAssetEvidence as evidence">
                    <dl class="evidence-list">
                        <div>
                            <dt>Risk Type</dt>
                            <dd>{{ evidence.risk_type || '--' }}</dd>
                        </div>
                        <div>
                            <dt>Failure Type</dt>
                            <dd>{{ evidence.failure_type || '--' }}</dd>
                        </div>
                        <div>
                            <dt>Criticality</dt>
                            <dd>{{ evidence.criticality || '--' }}</dd>
                        </div>
                        <div>
                            <dt>Main Concern</dt>
                            <dd>{{ evidence.main_concern || '--' }}</dd>
                        </div>
                        <div>
                            <dt>Narrative</dt>
                            <dd>{{ evidence.narrative || '--' }}</dd>
                        </div>
                        <div>
                            <dt>Recommended Action</dt>
                            <dd>{{ evidence.recommended_action || '--' }}</dd>
                        </div>
                        <div>
                            <dt>Bad Actor</dt>
                            <dd>{{ evidence.is_bad_actor ? 'Yes' : 'No' }}</dd>
                        </div>
                        <div>
                            <dt>Trend Summary</dt>
                            <dd>
                                <ng-container *ngIf="getTrendSummaryWithDatesOnly(evidence.trend_summary) as trendLines">
                                    <ng-container *ngIf="trendLines.length > 0; else noTrendSummary">
                                        <div *ngFor="let line of trendLines">{{ line }}</div>
                                    </ng-container>
                                </ng-container>
                                <ng-template #noTrendSummary>--</ng-template>
                            </dd>
                        </div>
                    </dl>
                </ng-container>
            </div>
        </aside>
    </div>
</section>
